import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-eight',
  templateUrl: './home-page-eight.component.html',
  styleUrls: ['./home-page-eight.component.scss']
})
export class HomePageEightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
